import React, { useEffect, useState } from 'react';
import Icon from '../Icon';
import { union } from '../../assets/svg';
import { SMALL_VIEWPORT, VIEWS_MAP } from '../../router/constants';

const VIEWPORT_WIDTH_TRIGGER = 1150;

const SmallViewport = ({ currentWidth }: { currentWidth: number }) => {
  const innerWidth = currentWidth;
  const [modalOpen, setModalOpen] = useState(true);
  const [shouldDisableViewPortModal, setShouldDisableViewPortModal] = useState(false);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (event.target === event.currentTarget) {
      setModalOpen(false);
    }
  };

  useEffect(() => {
    const ROUTES_TO_ALLOW_MOBILE = [VIEWS_MAP.VENDOR_DETAILS_REQUEST];
    if (ROUTES_TO_ALLOW_MOBILE.includes(window.location.pathname.replace('/', ''))) {
      setShouldDisableViewPortModal(true);
    } else {
      setShouldDisableViewPortModal(false);
    }
  }, [window.location.pathname]);

  return (
    <div className={shouldDisableViewPortModal ? 'hidden' : 'block'}>
      {innerWidth < VIEWPORT_WIDTH_TRIGGER && modalOpen && (
        <div
          role='button'
          tabIndex={0}
          onKeyDown={() => {}}
          onClick={handleClick}
          className={SMALL_VIEWPORT.UNFOCUSED_AREA}
        >
          <div className={SMALL_VIEWPORT.MESSAGE_AREA}>
            <Icon
              onClick={(event: React.MouseEvent<HTMLElement>) => handleClick(event)}
              className={SMALL_VIEWPORT.ICON}
              src={union}
            />
            <h1 className={SMALL_VIEWPORT.HEADING_STYLE}>{SMALL_VIEWPORT.HEADING}</h1>
            <h2 className={SMALL_VIEWPORT.TEXT_STYLE}>{SMALL_VIEWPORT.TEXT}</h2>
          </div>
        </div>
      )}
    </div>
  );
};
export default SmallViewport;
